<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="아이디 찾기" :type="'empty'" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section>
          <div class="guideMsg">
            <p class="txtL">
              <strong>웰몰</strong>
              가입여부를 확인하기 위해
              <br />
              필요한 정보입니다.
            </p>
          </div>

          <ValidationObserver ref="form">
            <div class="formArea">
              <span class="label">이름</span>
              <ValidationProvider name="이름" rules="required" vid="userName">
                <input type="text" id="ipt4" class="ipt" title="이름 입력" value="" v-model="userName" />
              </ValidationProvider>
              <span class="label">생년월일</span>
              <div class="setBirth">
                <input
                  type="tel"
                  class="ipt"
                  maxlength="4"
                  title="생년월일 년도 4자리"
                  placeholder="1990"
                  v-model="year"
                  v-onlyNum
                  nextTarget="mm"
                  v-skipOfMax
                />
                <span class="sign" aria-hidden="true">/</span>
                <input
                  type="tel"
                  class="ipt"
                  maxlength="2"
                  title="생년월일 월 2자리"
                  placeholder="01"
                  v-model="month"
                  v-onlyNum
                  nextTarget="dd"
                  v-skipOfMax
                  id="mm"
                />
                <span class="sign" aria-hidden="true">/</span>
                <input type="tel" class="ipt" maxlength="2" title="생년월일 일 2자리" placeholder="01" v-model="day" v-onlyNum id="dd" />
              </div>

              <ValidationProvider name="생년월일" rules="required|birth" vid="birth">
                <input type="hidden" id="birth" class="ipt" v-model="birth" />
              </ValidationProvider>

              <span class="label">휴대폰 번호</span>
              <ValidationProvider name="휴대폰번호" rules="required|cellNum" vid="cellNum">
                <input
                  type="tel"
                  id="phone_2"
                  class="ipt"
                  title="휴대폰 번호 입력"
                  placeholder="' - ' 없이 입력해주세요."
                  value=""
                  v-model="cellNum"
                  v-onlyNum
                />
              </ValidationProvider>
            </div>
          </ValidationObserver>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="isSearchId" :disabled="regButtonShow">
              확인
            </button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import { INPUT_INFO_CHECK } from '@/store/message.type';
import { isEmpty } from '@/common/common.function';

export default {
  name: 'findId',
  components: {
    MessagePop,
  },
  data: function() {
    return {
      headerTitle: '아이디 찾기',

      userName: null,
      year: null,
      month: null,
      day: null,
      cellNum: null,
      msg: null,
      messagePop: false,
      msgType: 'validation',

      regButtonShow: true,
    };
  },
  watch: {
    userName() {
      this.checkInput();
    },
    year() {
      this.checkInput();
    },
    month() {
      this.checkInput();
    },
    day() {
      this.checkInput();
    },
    cellNum() {
      this.checkInput();
    },
  },
  computed: {
    birth: function() {
      return this.year + this.month + this.day;
    },
  },
  methods: {
    isSearchId: function() {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
        } else {
          let urlPath = '/name/' + this.userName + '/cellNum/' + this.cellNum + '/birth/' + this.year.substring(2, 4) + this.month + this.day;

          await ApiService.service('GET', '/user' + urlPath)
            .then(({ data }) => {
              let makeParams = {
                success: false,
                userId: '',
              };

              if (data.result.accountCount > 0) {
                makeParams.success = true;

                const accountInfo = data.result.accountList[0];
                console.log(accountInfo);
                if (accountInfo.snsLoginYn == 'Y') {
                  this.msg =
                    `<b style="font-size: 15px;">회원정보확인</b><br>고객님께서는 <span style="color:#ff4f0a;">[` +
                    accountInfo.snsKind +
                    `]</span> 서비스를 통해 가입된 정보가 확인됩니다.<br>SNS 로그인을 이용해주세요.`;
                  this.msgType = 'sns';
                  this.messagePop = true;
                } else {
                  makeParams.userId = accountInfo.userId;
                  this.$router.replace({
                    name: 'findIdResult',
                    params: { makeParams },
                  });
                }
              } else {
                this.$router.replace({
                  name: 'findIdResult',
                  params: { makeParams },
                });
              }
            })
            .catch(({ response }) => {
              console.log('error : ' + response);
            });
        }
      });
    },
    close: function() {
      this.messagePop = false;
      if (this.msgType == 'sns') {
        this.$router.replace({ name: 'login' });
      }
    },
    checkInput() {
      if (!isEmpty(this.userName) && !isEmpty(this.year) && !isEmpty(this.month) && !isEmpty(this.day) && !isEmpty(this.cellNum)) {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
  },
};
</script>
